import { Modal } from '@design-system/components/modal/modal';
import { Typography } from '@design-system/components/typography/typography';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy, faEdit } from '@fortawesome/pro-regular-svg-icons';
import { ExternalLink } from '@design-system/components/link/externalLink';

export const LinksModal = ({
  isOpen,
  onClose,
  data,
}: {
  isOpen: boolean;
  onClose: () => void;
  data?: {
    links: Array<{
      title: string;
      url: string;
      description: string;
      edit?: () => void;
      copy: () => void;
    }>;
  };
}) => {
  if (!isOpen || !data) return null;
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Offer links"
      disableBackdropClick={true}
      modalClassName="w-full md:w-[742px]"
    >
      <div className="flex flex-col gap-6 justify-center">
        <div className="flex flex-col gap-4">
          {data.links.map((link) => (
            <div
              key={link.url}
              className="flex justify-between items-center bg-[#F8F8F8] rounded-lg py-2 px-4"
            >
              <div className="flex flex-col gap-2">
                <ExternalLink
                  href={link.url}
                  label={link.title}
                  textColor="P-80"
                  textVariant="body"
                  textSize="large"
                  fontWeight="bold"
                />
                <Typography variant="body" size="medium" fontWeight="normal">
                  {link.description}
                </Typography>
              </div>
              <div className="flex gap-4 h-full">
                {!link.edit ? null : (
                  <FontAwesomeIcon
                    icon={faEdit}
                    onClick={link.edit}
                    className="cursor-pointer"
                    size="lg"
                  />
                )}
                <FontAwesomeIcon
                  icon={faCopy}
                  onClick={link.copy}
                  className="cursor-pointer"
                  size="lg"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </Modal>
  );
};
